import Rate from './rate'

Rate.install = vue => {
  vue.component(Rate.name, Rate)
}

export default Rate
